// extracted by mini-css-extract-plugin
export default {"containerListagem":"styles_containerListagem__YpXyy","searchBar":"styles_searchBar__kEpUk"};